export const setPCUID = pcuid => {
  document.cookie = `pcuid=${pcuid}`;
};

export const setPCSID = pcsid => {
  document.cookie = `pcsid=${pcsid}`;
};

export const getPCUID = () =>
  document.cookie.replace(/(?:(?:^|.*;\s*)pcuid\s*=\s*([^;]*).*$)|^.*$/, "$1");

export const getPCSID = () =>
  document.cookie.replace(/(?:(?:^|.*;\s*)pcsid\s*=\s*([^;]*).*$)|^.*$/, "$1");
